"use client"

import { Header } from "@/components/header"
import { Footer } from "@/components/footer"
import { ArrowRight, Code, Zap, Users, BookOpen, Star } from "lucide-react"
import Link from "next/link"
import { useEffect, useRef } from "react"
import { HeroAnimation } from "@/components/animations/hero-animation"
import { ScrollReveal } from "@/components/animations/scroll-reveal"
import { StudentTestimonials } from "@/components/student-testimonials"
import Image from "next/image"

export default function Home() {
  const statsRef = useRef(null)

  useEffect(() => {
    if (typeof window === "undefined") return

    const gsap = (window as any).gsap
    const ScrollTrigger = (window as any).ScrollTrigger

    if (!gsap) {
      console.log("[v0] GSAP not loaded")
      return
    }

    if (gsap.registerPlugin && ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger)

      // Parallax effect on hero
      const heroImage = document.querySelector("[data-parallax]")
      if (heroImage) {
        gsap.to(heroImage, {
          scrollTrigger: {
            trigger: heroImage,
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
          y: 100,
          ease: "none",
        })
      }
    }
  }, [])

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-white to-blue-50 ">
      <Header />

      {/* Hero Section */}

      {/* <section
        className="relative h-screen bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: "url('/banner.png')", // 👈 put your image in /public/hero-bg.jpg
        }}
      >

      </section> */}

      {/* Hero Section */}
      <section
        className="relative h-screen bg-center bg-no-repeat bg-cover bg-fixed"
        style={{
          backgroundImage: `url('/banner.png')`,
        }}
      >
        {/* Switch background for mobile */}
        <style jsx>{`
    @media (max-width: 768px) {
      section {
        background-image: url('/banner2.png') !important;
        background-attachment: fixed;
      }
    }
  `}</style>

        {/* Overlay for contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/30"></div>

        {/* Apply Now Button (top-right) */}
        {/* <div className="absolute top-8 right-8 z-10">
    <Link
      href="/admissions"
      className="inline-block bg-gradient-to-r from-blue-500 to-blue-700 text-white px-8 py-3 text-lg font-semibold rounded-full shadow-lg
                 hover:scale-105 hover:shadow-blue-500/50 hover:from-white hover:to-white hover:text-blue-600 hover:border-2 hover:border-blue-600
                 transition-all duration-300"
    >
      Apply Now
    </Link>
  </div> */}
      </section>



      {/* Stats Section */}
      {/* <section
        ref={statsRef}
        className="bg-gradient-to-r from-primary-blue to-primary-blue-dark py-16 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
          {[
            { value: "5K+", label: "Active Students" },
            { value: "50+", label: "Expert Instructors" },
            { value: "100+", label: "Courses Available" },
            { value: "95%", label: "Satisfaction Rate" },
          ].map((stat, idx) => (
            <ScrollReveal key={idx} delay={idx * 0.1}>
              <div className="text-center text-white">
                <div className="font-display font-bold text-4xl mb-2">{stat.value}</div>
                <p className="text-blue-100">{stat.label}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </section> */}
      <section
        ref={statsRef}
        className="relative bg-white py-20 px-6 sm:px-8 lg:px-12 overflow-hidden"
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10">
          {[
            { value: "5K+", label: "Active Students" },
            { value: "10+", label: "Expert Instructors" },
            { value: "15+", label: "Courses Available" },
            { value: "95%", label: "Satisfaction Rate" },
          ].map((stat, idx) => (
            <ScrollReveal key={idx} delay={idx * 0.1}>
              <div className="group relative text-center bg-gradient-to-br from-white to-blue-50 border border-blue-100 rounded-2xl shadow-md p-10 hover:shadow-xl hover:-translate-y-1 transition-all duration-500">
                <div className="font-display font-extrabold text-5xl md:text-6xl mb-2 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-400">
                  {stat.value}
                </div>
                <p className="text-gray-700 text-lg font-medium tracking-wide group-hover:text-blue-600 transition-colors">
                  {stat.label}
                </p>

                {/* Glow accent on hover */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-500/10 to-cyan-400/10 opacity-0 group-hover:opacity-100 blur-xl transition duration-700"></div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </section>


      {/* Features Section */}
      {/* <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-display font-bold text-4xl md:text-5xl text-gray-900 mb-4">
              Why Choose CodifyInstitute?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Everything you need to become a professional developer
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: Code,
                title: "Hands-On Projects",
                desc: "Build real applications from day one with industry-standard tools and practices.",
              },
              {
                icon: Users,
                title: "Expert Mentorship",
                desc: "Learn directly from senior developers with 10+ years of industry experience.",
              },
              {
                icon: Zap,
                title: "Career Ready",
                desc: "Get job-ready with portfolio projects, resume help, and interview prep.",
              },
              {
                icon: BookOpen,
                title: "Comprehensive Curriculum",
                desc: "Cover everything from fundamentals to advanced concepts and best practices.",
              },
              {
                icon: Star,
                title: "Community Support",
                desc: "Join a thriving community of learners and developers for support and collaboration.",
              },
              {
                icon: ArrowRight,
                title: "Flexible Learning",
                desc: "Learn at your own pace with lifetime access to course materials and updates.",
              },
            ].map((feature, idx) => (
              <ScrollReveal key={idx} delay={idx * 0.1}>
                <div className="p-8 bg-off-white rounded-lg hover:shadow-lg transition hover:scale-105 duration-300">
                  <feature.icon size={32} className="text-primary-blue mb-4" />
                  <h3 className="font-display font-bold text-xl mb-2 text-gray-900">{feature.title}</h3>
                  <p className="text-gray-600">{feature.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section> */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <div className="max-w-7xl mx-auto relative z-10">
          {/* Animated Heading */}
          <ScrollReveal delay={0.1}>
            <div className="text-center mb-16">
              <h2 className="font-display font-bold text-4xl md:text-5xl text-gray-900 mb-4 animate-slide-up">
                Why Choose <span className="text-blue-600">CodifyInstitute?</span>
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto animate-fade-in">
                Everything you need to become a professional developer
              </p>
            </div>
          </ScrollReveal>

          {/* Animated Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: Code,
                title: "Hands-On Projects",
                desc: "Build real applications from day one with industry-standard tools and practices.",
              },
              {
                icon: Users,
                title: "Expert Mentorship",
                desc: "Learn directly from senior developers with 10+ years of industry experience.",
              },
              {
                icon: Zap,
                title: "Career Ready",
                desc: "Get job-ready with portfolio projects, resume help, and interview prep.",
              },
              {
                icon: BookOpen,
                title: "Comprehensive Curriculum",
                desc: "Cover everything from fundamentals to advanced concepts and best practices.",
              },
              {
                icon: Star,
                title: "Community Support",
                desc: "Join a thriving community of learners and developers for support and collaboration.",
              },
              {
                icon: ArrowRight,
                title: "Flexible Learning",
                desc: "Learn at your own pace with  access to course materials and updates.",
              },
            ].map((feature, idx) => (
              <ScrollReveal key={idx} delay={idx * 0.15}>
                <div className="relative p-8 bg-white rounded-2xl border border-blue-100 shadow-md hover:shadow-xl hover:-translate-y-2 transition-all duration-500 group">
                  <div className="absolute -top-4 -left-4 w-10 h-10 bg-blue-100 rounded-full group-hover:scale-125 transition-transform"></div>
                  <feature.icon size={40} className="text-blue-600 mb-4 relative z-10" />
                  <h3 className="font-display font-bold text-xl mb-2 text-gray-900 relative z-10">{feature.title}</h3>
                  <p className="text-gray-600 relative z-10">{feature.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>

        {/* Floating Animation Keyframes */}
        <style jsx>{`
    .animate-slide-up {
      animation: slideUp 1s ease-out forwards;
    }
    .animate-fade-in {
      animation: fadeIn 1.5s ease-out forwards;
    }
    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `}</style>
      </section>


      <StudentTestimonials />
      

      <Footer />

    </div>
  )
}